import { createFileRoute } from "@tanstack/react-router";
import { TripDetailPageClient } from "@/components/trips/trip-detail-page-client";

function TripDetailPage() {
  return <TripDetailPageClient />;
}

export const Route = createFileRoute("/_app/trips/$id")({
  component: TripDetailPage,
});
